export default [
    {
        path: "/material/image/list1",
        name: "material-image-list1",
        component: () => import("@/views/material/imageList1.vue"),
    },
    {
        path: "/material/image/list2",
        name: "material-image-list2",
        component: () => import("@/views/material/imageList2.vue"),
    },
]